
import HinaSwitch from "@/views/ai-builder-component/baseComponent/hina-switch.vue";
import { TableDataItem } from "@/lib/model/exambuilder/exam-component/component";

export default {
  name: "DialogForLibQuestion",
  components: {
    HinaSwitch
  },
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  data() {
    return {
      RECOMMEND_CODE: 1 // 是否推荐，推荐为1
    };
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    setVisibleForAdd: {
      type: Function,
      required: false
    },
    setLink: {
      type: Function,
      required: false
    },
    checkedList: {
      type: Array,
      required: false
    }
  },
  computed: {
    localVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      }
    },
    tableData(): TableDataItem[] {
      return (this.checkedList || []) as TableDataItem[];
    }
  },
  methods: {
    // 点击移除
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    handleClick(row) {
      const _checkedList = this.checkedList.filter(ele => ele !== row);
      this.$emit("updateLinkDetail", _checkedList);
    },
    addQuestion(): void {
      this.setVisibleForAdd(true);
    },
    onMainSwitchChange(item): void {
      this.setLink(item);
    },
    back(): void {
      this.$emit("update:visible", false); // 设置弹窗消失
    }
  }
};
